module.exports = __webpack_public_path__ + "img/Image 5.db0cdac4.png";